import React from 'react';
import { cn } from '@/utils';
import { SkeletonBlock } from './skeletonBlock';

interface DataTableSkeletonProps {
  columns: number;
  rows?: number;
}

export function DataTableSkeleton({ columns, rows = 10 }: DataTableSkeletonProps) {
  const fakeRows = Array.from({ length: rows });

  return (
    <>
      {fakeRows?.map((_, rowIndex) => (
        <tr key={rowIndex} className={cn('border-b border-border')}>
          {Array.from({ length: columns }).map((__, colIndex) => (
            <td key={colIndex} className="px-2 py-1">
              <SkeletonBlock className="h-8 w-full" />
            </td>
          ))}
        </tr>
      ))}
    </>
  );
}
